import React from "react";
import { Fragment } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import { getUserOrderList } from "../../../../services/orders";
import AuthContext from "../../../../store/context/auth-context";
import { stringToDate } from "../../../../utils/GeneralFunc";

// import { getUserOrderList } from "../../Services/order";

import classes from "./OrderTrackerList.module.css";

const OrderTrackerList = () => {
  const authCtx = useContext(AuthContext);

  //Destructuring UserData of useId
  const  userId  = authCtx?.userData?.id;

  const {
    sendRequest,
    status,
    data: orderList,
    error,
  } = useHttp(getUserOrderList, true);

  useEffect(() => {
    sendRequest(userId);
  }, [sendRequest, userId]);

  if (status === "pending") {
    return <div className="centered">loading</div>;
  }

  if (error) {
    return <div></div>;
  }
  if (status === "completed" && (!orderList || orderList.length === 0)) {
    return <div className="centered">There are no orders yet.</div>;
  }
  return (
    <div>
       <div className={classes["track-title"]}>My Last Order</div>
      {orderList
        .reverse()
        .slice(0, 3)
        .map((order) =>
          order.orderDetails.map((od, i) => (
            <p key={i} className={classes["last-order"]}>
              <Link to={`profile/my_orders/order_detail/${od.orderDetailId}`}>
                {stringToDate(order.orderDate)} - Order {order.orderNumber}
              </Link>
            </p>
          ))
        )}
    </div>
  );
};

export default OrderTrackerList;
